import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import cookie from 'js-cookie'
import router from '../router'
// localStorage.setItem('url','http://gdtest.harborn.cn/GDDB/')
localStorage.setItem('url','http://fzjz.harborn.cn/FZJZ/api/')
// create an axios instance
 
const service = axios.create({
  // baseURL: 'http://gdtest.harborn.cn/GDDB/', // process.env.VUE_APP_BASE_API
  baseURL: process.env.VUE_APP_BASE_API, // process.env.VUE_APP_BASE_API
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 1800000, // request timeout,
  transformRequest: [
    function(data) {
      var ret = ''
      for (var it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      ret = ret.substring(0, ret.lastIndexOf('&'))

      return ret
    }
  ],
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Content-Type': 'application/x-www-form-urlencoded',
    // "Access-Control-Allow-Credentials": true,
    // "Access-Control-Allow-Origin": 'http://gdtest.harborn.cn/GDDB'
  },
})
// request interceptor
  
service.interceptors.request.use(
  config => {
    // do something before request is sent
    
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

      config.headers['token'] = store.getters.token
    }
    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // console.log('response.dataresponse.dataresponse.data',response);
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    let allCookies = document.cookie 
   
  
    // cookie.set('JSESSIONID','A434C5E05C27FAB4763AC96225C69770')  
    // cookie.set('rememberMe','deleteMe')  
    // cookie.set('rememberMe','VpyzGpWOG/HwvZxlHlMEZR+S5fHKiHwDU32ObCkZL6m5B8W3VR0wjYiNRDUCy7w7XlFLolHqo6RPHIkxSK8KaORUB2r+ya3WrN2XcuxRQijQRjNTmpgxj+aLz4Ci2RjJBxjHghWrufJn5BzSIP9bzP0hzQmcnuaAD2uC5884w2/ArBt6udPHvG4DNDxFMt5Ajr5yCGEmiwsQ0dxzUQwBoZ4SfID0YgtICmWEj+s/8t/M0kLbfaqgWXQWiDkRLxGIwWckzo7G3l4nldMS/+wpDbxhq4p7xx8ISUjjBjLtEgR1RcXIPXkGDpB8yHzNqoYaVti8WHw/LNPHs+W6kwteq7IA7Dj4RwGliO+1HaG4vgQkczwjvUqOPymYRK7Pwc3rm0ycEbfTjDp6iNYimHKNKcvxSUJ8wuUY1RVg4ALuKUEFv0Z1AnmLu15q6tjcqjZm1d2os6cvJbeCLYaFxfJleeAfZmsFuh3Ae/QbvCydosgP5izUYr6a/OqFozOTU/g1Cr+L3enLspxrdvB5eIPqa2p+my+DG1O9x9NWQVc2+dgisDyaVD3hfvsywDoS97bx+CPtXysbo7tSv5A0nkIX6o84KfW5m3T8BAj1RfaU58iwmaNWTgZO7GtJRHo2PZGJik42fPcsG3Bo/XxONRhRu5DpFISglSiBZO2OeAqxnnQCsXZu7TUMI5DEvYH2GHlTQ1h/hHJPGqVZk95fORsRra89sXMCv1ldRG60/Hqv5L7JOdNcUUltB0J01caWNq9jwr7idHl1WjYN2RMpqMB51pqzV3VOQJhS5LmdyrpnPaPm+S1ergEZfV+UBvx+GS0QdnTCbg9DGAvcyxiC7fxI9D47b6vcU0bb6fYj2CZ18L/xsyL0LO0RDyPZcUPbn6jPsnTHqRpkrcPa0uSdjdODBj4iZRzfxUpz0tJkj0iXRVF+lg1owinJkh6oIacl7PSD2UnIj3aq41r//T9YblLbqpB/iwZb9tMYr1Dzqr0mWRSlRPqRLtmLgv5ye/okSsqNb5faJZb9KV00oqw3HqqFYhJmwnBktqREf44ZlHrBrp3zMvKXNTny47luwORF+p65CWY/qEnN2x88U5cwUPUPBpDpbp5k4FzpccoYGU9P')  
    if (res.code !== 200 && res.code) {

      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // localStorage.setItem("name",'')
    // console.log('err' + error) // for debug
    // router.push({path: '/login'})
    // Message({
    //   message: error.msg,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    // return Promise.reject(error)
  }
)
console.log(service,'serviceserviceserviceserviceserviceservice')
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js